export var Palm = {
  chainId: 11297108109,
  chainName: 'Palm',
  isTestChain: false,
  isLocalChain: false,
  multicallAddress: '0x99a73dfE34578348fb81BD078201C0BA84E9c840',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://explorer.palm.io/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://explorer.palm.io/tx/".concat(transactionHash);
  }
};
export var PalmTestnet = {
  chainId: 11297108099,
  chainName: 'Palm Testnet',
  isTestChain: true,
  isLocalChain: false,
  multicallAddress: '0x99a73dfE34578348fb81BD078201C0BA84E9c840',
  getExplorerAddressLink: function getExplorerAddressLink(address) {
    return "https://explorer.palm-uat.xyz/address/".concat(address);
  },
  getExplorerTransactionLink: function getExplorerTransactionLink(transactionHash) {
    return "https://explorer.palm-uat.xyz/tx/".concat(transactionHash);
  }
};
export default {
  Palm: Palm,
  PalmTestnet: PalmTestnet
};